// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .aw-pardot-form .aw-form{font-family:var(--font-family)!important;font-size:1em!important;line-height:normal!important}#aw--c #aw-sl .aw-pardot-form .aw-pardot-form iframe{width:100%!important;height:var(--aw-form-iframe-height)!important}", ""]);
// Exports
module.exports = exports;
